module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-5-011557cf9f42db7f0432c6532b8cb4eb.png";